import { Link } from "react-router-dom";
import type { HdmgdjConfig } from "@/config/hdmgdjConfig";

interface HdmgdjCtaProps {
  config: HdmgdjConfig;
}

const HDMGDJ_LIE =
  "/images/mascot-cta.png";

export default function HdmgdjCta({ config }: HdmgdjCtaProps) {
  return (
    <section className="relative w-full bg-foreground-950 py-16 md:py-20 overflow-hidden">
      <div className="hdmgdj-atmos hdmgdj-atmos-soft" aria-hidden="true" />
      <div className="hdmgdj-container relative">
        <div className="flex flex-col lg:flex-row lg:items-center gap-10 justify-between">
          <div className="max-w-2xl">
            <h2 className="font-heading text-background-50 text-[28px] md:text-[42px] leading-tight">
              现在就开始你的
              <span className="text-primary-500"> 魔改之旅</span>
            </h2>
            <p className="mt-5 text-[15px] leading-8 text-background-200">
              {"海量经典魔改短剧已经上架，"}
              <span className="text-primary-300 font-medium">{"黄豆魔改短剧APP下载"}</span>
              {"后即刻开追，新剧每日不断更新。"}
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Link
                to="/hdmgdj-download"
                className="inline-flex items-center gap-2 h-12 md:h-[52px] px-7 rounded-md bg-primary-500 text-foreground-950 text-[16px] font-label font-bold whitespace-nowrap hover:bg-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-download-2-line text-xl" />
                前往下载页
              </Link>
              <a
                href={config.downloadUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 h-12 md:h-[52px] px-6 rounded-md border border-background-50/25 text-background-100 text-[15px] font-label whitespace-nowrap hover:border-primary-500 hover:text-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-external-link-line text-xl" />
                官方下载地址
              </a>
            </div>
            <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-3">
              {config.platforms.map((p) => (
                <span key={p.key} className="inline-flex items-center gap-2 text-[13px] font-label text-background-200/85">
                  <i className={`${p.icon} text-base text-primary-400`} />
                  {p.shortName}
                </span>
              ))}
            </div>
          </div>

          <img
            src={HDMGDJ_LIE}
            alt="黄豆魔改短剧吉祥物"
            title="黄豆魔改短剧吉祥物"
            className="w-[190px] md:w-[260px] h-auto self-center lg:self-auto hdmgdj-float-slow"
          />
        </div>
      </div>
    </section>
  );
}